/* eslint-disable jsx-control-statements/jsx-use-if-tag */

import React, { useEffect, useState } from 'react'
import { sendClevertapUIActionEvent as ClevertapEvent } from 'AccountsUtils'
import './profile.scss'
import './_unifiedlogin.scss'

import Toast from 'Lib/Toast'

import PageLoader from 'Lib/Pageloader'
import { getUserProfileDetails } from '../../pages/Trips/trips.helper'

import Handlepiclick from './Handlepiclick'
import GSTContainer from './GSTContainer'
import EmailContainer from './EmailContainer'
import MobContainer from './MobContainer'
import ErrorScreen from './comps/ErrorScreen'
import {
  checkDeviceType,
  isEmpty,
  path,
  sendSignoutNativeAndroidCallback,
  sendSignoutNativeIosCallback,
} from '../../utils/index'

const Profile = () => {
  const [apiError, setApiError] = useState(false)

  const [isMOpaque, setIsMOpaque] = useState(false)
  const [isEOpaque, setIsEOpaque] = useState(false)
  const [isPOpaque, setIsPOpaque] = useState(false)
  const [isGOpaque, setIsGOpaque] = useState(false)
  const [isLIOpaque, setIsLIOpaque] = useState(false)
  const [isMobVisible, setIsMobVisible] = useState(false)
  const [toastMessagex, setToastMessagex] = useState('')
  const [isEmailLinked, setIsEmailLinked] = useState(false)
  const [showPageLoader, setShowPageLoader] = useState(false)

  const [userDetail, setUserDetail] = useState({})
  const getUserDetails = async () => {
    setShowPageLoader(true)
    try {
      const response = await getUserProfileDetails()
      const { status, data, error } = response
      window.check99 = response
      if (status === 200) {
        setUserDetail(data)
      } else if (status !== 200 && !isEmpty(error)) {
        setApiError(true)
        if (
          error?.response?.status === 401 &&
          error?.response?.data?.message === 'INVALID_SESSION'
        ) {
          const userAgent = path(
            ['navigator', 'userAgent'],
            window
          )?.toLowerCase()
          const safari = /safari/.test(userAgent)
          const ios = /iphone|ipod|ipad/.test(userAgent)
          const deviceType = checkDeviceType()
          if (deviceType === 'AndroidApp') {
            sendSignoutNativeAndroidCallback()
          } else if (deviceType === 'iPhoneApp' || (ios && !safari)) {
            sendSignoutNativeIosCallback()
          }
          window.location.href = '/signout'
        }
      }
    } catch (e) {
      setApiError(true)
      console.error(e)
    }
    setShowPageLoader(false)
  }
  useEffect(() => {
    getUserDetails()
    ClevertapEvent({
      action_name: 'profile_clicked',
      page_name: 'accounts',
      platform: 'Desktop',
      is_logged_in: 'Yes',
      domainName: window && window.location.hostname,
    })
  }, [])

  useEffect(() => {
    const bannerTimer = setTimeout(() => {
      setToastMessagex('')
    }, 3000)
    return () => {
      clearTimeout(bannerTimer)
    }
  }, [toastMessagex])

  return apiError ? (
    <ErrorScreen />
  ) : (
    <>
      {showPageLoader && <PageLoader />}

      <div className="overlay1" />

      <div className="main flex">
        <div className="heading1 mb-4">Profile</div>
        <div className="bs-border t-8 flex flex-column ">
          <div
            className={`mt-4 fs-6 fw-600 ${isLIOpaque ? 'op-low' : 'op-high'}`}
          >
            Login information
          </div>
          <MobContainer
            setIsGOpaque={setIsGOpaque}
            setIsPOpaque={setIsPOpaque}
            setIsMOpaque={setIsMOpaque}
            setIsEOpaque={setIsEOpaque}
            isMOpaque={isMOpaque}
            setToastMessagex={setToastMessagex}
            isMobVisible={isMobVisible}
            setIsMobVisible={setIsMobVisible}
            userDetail={userDetail}
            setUserDetail={setUserDetail}
          />

          <EmailContainer
            setIsGOpaque={setIsGOpaque}
            setIsPOpaque={setIsPOpaque}
            setIsMOpaque={setIsMOpaque}
            setIsEOpaque={setIsEOpaque}
            isEOpaque={isEOpaque}
            userDetail={userDetail}
            setToastMessagex={setToastMessagex}
            setUserDetail={setUserDetail}
            setIsEmailLinked={setIsEmailLinked}
            isEmailLinked={isEmailLinked}
          />
        </div>

        <div
          className={`mt-14 flex flex-column ${
            isPOpaque ? 'op-low' : 'op-high'
          }`}
        >
          <Handlepiclick
            setIsGOpaque={setIsGOpaque}
            setIsPOpaque={setIsPOpaque}
            setIsMOpaque={setIsMOpaque}
            setIsEOpaque={setIsEOpaque}
            setIsLIOpaque={setIsLIOpaque}
            setToastMessagex={setToastMessagex}
            userDetail={userDetail}
            setUserDetail={setUserDetail}
          />
        </div>
        {/* <GSTContainer
          setIsGOpaque={setIsGOpaque}
          setIsPOpaque={setIsPOpaque}
          setIsMOpaque={setIsMOpaque}
          setIsEOpaque={setIsEOpaque}
          setIsLIOpaque={setIsLIOpaque}
          setToastMessagex={setToastMessagex}
          userDetail={userDetail}
          setUserDetail={setUserDetail}
          isGOpaque={isGOpaque}
        /> */}
        <Toast
          messageType="null"
          message={toastMessagex}
          isVisible={toastMessagex}
          containerClass="toastCss"
          showCloseButton={false}
        />
      </div>
    </>
  )
}

export default Profile
